const normalize = (list) =>
  (Array.isArray(list) ? list : [])
    .map((partNumber) =>
      String(partNumber ?? '')
        .trim()
        .toUpperCase(),
    )
    .filter((partNumber) => partNumber !== '');

const countBy = (list) =>
  list.reduce(
    (counts, partNumber) =>
      counts.set(partNumber, (counts.get(partNumber) ?? 0) + 1),
    new Map(),
  );

const distinct = (list) => [...new Set(list)];

const repeat = (partNumber, times) =>
  Array.from({ length: Math.max(0, times) }, () => partNumber);

export const computeHeaterChanges = (
  currentPartNumbers,
  desiredPartNumbers,
  { visibleCount } = {},
) => {
  const current = normalize(currentPartNumbers);
  const desired = normalize(desiredPartNumbers);

  const deletable =
    visibleCount === undefined ? current : current.slice(0, visibleCount);

  const currentCounts = countBy(current);
  const desiredCounts = countBy(desired);
  const deletableCounts = countBy(deletable);

  return {
    toAdd: distinct(desired).flatMap((partNumber) =>
      repeat(
        partNumber,
        desiredCounts.get(partNumber) - (currentCounts.get(partNumber) ?? 0),
      ),
    ),
    toDelete: distinct(deletable).flatMap((partNumber) =>
      repeat(
        partNumber,
        deletableCounts.get(partNumber) - (desiredCounts.get(partNumber) ?? 0),
      ),
    ),
  };
};

export const removeDeletedSpecs = (specs, toDelete) => {
  const remaining = countBy(normalize(toDelete));

  return (Array.isArray(specs) ? specs : [])
    .filter((spec) => spec?.partNumber)
    .filter((spec) => {
      const partNumber = String(spec.partNumber).trim().toUpperCase();
      const outstanding = remaining.get(partNumber) ?? 0;
      if (outstanding === 0) {
        return true;
      }
      remaining.set(partNumber, outstanding - 1);
      return false;
    });
};
